import { Location, WorkplaceCompressedDto, WorkplaceCompressedDtoTypeEnum } from '@jooxter/api';
import { IJxtWorkplaceHalfDay, JxtWorkplaceTypeEnum } from '@jooxter/utils';
import { useCallback } from 'react';

const JxtWorkplaceTypeMapping = {
  [WorkplaceCompressedDtoTypeEnum.WorkFromHome]: JxtWorkplaceTypeEnum.WorkFromHome,
  [WorkplaceCompressedDtoTypeEnum.Mission]: JxtWorkplaceTypeEnum.Mission,
  [WorkplaceCompressedDtoTypeEnum.Office]: JxtWorkplaceTypeEnum.Office,
  [WorkplaceCompressedDtoTypeEnum.Off]: JxtWorkplaceTypeEnum.Off,
  [WorkplaceCompressedDtoTypeEnum.Unknown]: JxtWorkplaceTypeEnum.Unknown,
};

export const useWorkplaceCompressedDtoToIJxtWorkplaceHalfDayAdapter = (locations: Location[]) => {
  const adapt = useCallback(
    (workplaceHalfDay: WorkplaceCompressedDto): IJxtWorkplaceHalfDay => {
      const location = workplaceHalfDay.locationId
        ? locations?.find((location) => location.id === workplaceHalfDay.locationId)
        : undefined;

      return {
        id: workplaceHalfDay.id,
        type: JxtWorkplaceTypeMapping[workplaceHalfDay.type],
        locationName: location?.name,
        locationId: workplaceHalfDay.locationId,
        capabilities: {
          ...workplaceHalfDay.capabilities,
        },
      };
    },
    [locations]
  );

  return { adapt };
};
